<interacta-dialog
    [contentOverflowAuto]="false"
    [isOpen]="isOpen()"
    [size]="RelationDialogConfig()[page()].dialogSize"
    (closing)="close()"
>
    @let _item = item();
    @let _sourcePost = sourcePost();

    <h2 class="flex gap-x-16 typo-t6" title>
        {{
            RelationDialogConfig()[page()].title
                | translate: { communityName: _item?.name || '' }
        }}
    </h2>

    <interacta-dialog-description>
        {{ RelationDialogConfig()[page()].description | translate }}
    </interacta-dialog-description>

    <div class="flex min-h-0 flex-col" content>
        @switch (page()) {
            @case ('community') {
                <interacta-relations-dialog-community
                    [inverseLinks]="inverseLinks()"
                    [selectedItem]="item()"
                    (back)="back()"
                    (selectLink)="selectLink($event.link)"
                />
            }
            @case ('link-results') {
                @if (linkResults(); as linkResults) {
                    <interacta-relations-dialog-link-results
                        [linkResults]="linkResults"
                        (back)="back()"
                    />
                }
            }
            @case ('field') {
                @if (_item && _item.linkedBy.postLinkFieldDefinitions) {
                    <interacta-relations-dialog-field
                        [inverseLink]="_item"
                        (back)="back()"
                        (selectLink)="selectLink($event.link)"
                    />
                }
            }
            @case ('create') {
                <button
                    class="mb-16"
                    interacta-button
                    type="button"
                    [icon]="'relations'"
                    [label]="
                        'RELATIONS_DIALOG.CREATE.' +
                            activityAddonLabel() +
                            'LINK_TO_EXISTING' | translate
                    "
                    [size]="'small'"
                    [style]="'tonal'"
                    (click)="changePage('link')"
                ></button>

                @if (
                    _item && _item.linkedBy.postLinkFieldDefinitions && isOpen()
                ) {
                    <interacta-post-fast-create
                        class="flex min-h-0 grow"
                        [communityId]="_item.linkedBy.community.id"
                        [communityType]="linkedCommunityType()"
                        [linkedFieldId]="
                            _item.linkedBy.postLinkFieldDefinitions[0].id
                        "
                        [sourcePostId]="_sourcePost?.id"
                        (back)="back()"
                    />
                }
            }
            @case ('link') {
                <button
                    class="mb-16"
                    interacta-button
                    type="button"
                    [icon]="'plus'"
                    [label]="
                        'RELATIONS_DIALOG.LINK.' +
                            activityAddonLabel() +
                            'CREATE_AND_LINK' | translate
                    "
                    [size]="'small'"
                    [style]="'tonal'"
                    (click)="changePage('create')"
                ></button>
                @if (
                    _item &&
                    _item.linkedBy.postLinkFieldDefinitions &&
                    _sourcePost
                ) {
                    <interacta-post-picker-advanced
                        class="flex min-h-0 grow"
                        [mode]="'inverse'"
                        [posts]="posts()"
                        [showLoader]="isLinkingPost()"
                        (applyFilter)="
                            loadInversePosts(_item, $event.filters, _sourcePost)
                        "
                        (back)="back()"
                        (selectPosts)="
                            linkToPosts(
                                _sourcePost,
                                $event.posts,
                                _item.linkedBy.postLinkFieldDefinitions[0]
                            )
                        "
                    />
                }
            }
        }
    </div>
</interacta-dialog>
